import { createContext } from "react";

const LogadoContext = createContext();

export default LogadoContext;